import Vue from "vue";
import Router from "vue-router";
// import HelloWorld from '@/components/HelloWorld'
Vue.use(Router);
const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};
const VueRouterReplace = Router.prototype.replace;
Router.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch(err => err);
};

let vuerouter = new Router({
  mode: "history", //去掉#号
  routes: [
    {
      path: "/",
      name: "login",
      component: resolve => require(["../components/login"], resolve)
    },
    {
      path: "/home",
      name: "home",
      component: resolve => require(["../components/home/root.vue"], resolve),
      children: [
        {
          path: "homeIndex",
          name: "homeIndex",
          meta: { title: "主页" },
          component: resolve =>
            require(["../components/home/index.vue"], resolve)
        },
        {
          path: "homeYuEMIngXi",
          name: "homeYuEMIngXi",
          meta: { title: "余额明细" },
          component: resolve =>
            require(["../components/home/YuEMIngXi.vue"], resolve)
        },
        {
          path: "ShangHuGuanLiIndex",
          name: "ShangHuGuanLiIndex",
          meta: { title: "商户管理" },
          component: resolve =>
            require(["../components/ShangHuGuanLi/index.vue"], resolve)
        },
        {
          path: "ShangHuGuanLiZiShangHu",
          name: "ShangHuGuanLiZiShangHu",
          meta: { title: "子商户列表" },
          component: resolve =>
            require(["../components/ShangHuGuanLi/ZiShangHu.vue"], resolve)
        },
        {
          path: "ShangHuGuanLiTongDaolLieBiao",
          name: "ShangHuGuanLiTongDaolLieBiao",
          meta: { title: "支付通道列表" },
          component: resolve =>
            require([
              "../components/ShangHuGuanLi/TongDaolLieBiao.vue"
            ], resolve)
        },
        {
          path: "ShangHuGuanLiShangHuFenZhang",
          name: "ShangHuGuanLiShangHuFenZhang",
          meta: { title: "商户分账" },
          component: resolve =>
            require([
              "../components/ShangHuGuanLi/ShangHuFenZhang.vue"
            ], resolve)
        },
        {
          path: "ShangHuGuanLiFeiLv",
          name: "ShangHuGuanLiFeiLv",
          meta: { title: "费率列表" },
          component: resolve =>
            require(["../components/ShangHuGuanLi/FeiLv.vue"], resolve)
        },
        {
          path: "DingDanGuanLiTuiKuanJiLu",
          name: "DingDanGuanLiTuiKuanJiLu",
          meta: { title: "退款记录" },
          component: resolve =>
            require(["../components/DingDanGuanLi/TuiKuanJiLu.vue"], resolve)
        },
        {
          path: "DingDanGuanLiZhiFuDingDan",
          name: "DingDanGuanLiZhiFuDingDan",
          meta: { title: "支付订单" },
          component: resolve =>
            require(["../components/DingDanGuanLi/ZhiFuDingDan.vue"], resolve)
        },
        {
          path: "DingDanGuanLiTouSuJiLu",
          name: "DingDanGuanLiTouSuJiLu",
          meta: { title: "投诉记录" },
          component: resolve =>
            require(["../components/DingDanGuanLi/TouSuJiLu.vue"], resolve)
        },
        {
          path: "DingDanGuanLiFengZhangJiLu",
          name: "DingDanGuanLiFengZhangJiLu",
          meta: { title: "分账记录" },
          component: resolve =>
            require(["../components/DingDanGuanLi/FengZhangJiLu.vue"], resolve)
        },
        {
          path: "DingDanGuanLiTuiFenZhangJiLu",
          name: "DingDanGuanLiTuiFenZhangJiLu",
          meta: { title: "退分账记录" },
          component: resolve =>
            require([
              "../components/DingDanGuanLi/TuiFenZhangJiLu.vue"
            ], resolve)
        },
        {
          path: "DingDanGuanLiTiXianJiLu",
          name: "DingDanGuanLiTiXianJiLu",
          meta: { title: "提现记录" },
          component: resolve =>
            require(["../components/DingDanGuanLi/TiXianJiLu.vue"], resolve)
        },
        {
          path: "ShuJuTongJiIndex",
          name: "ShuJuTongJiIndex",
          meta: { title: "月数据统计" },
          component: resolve =>
            require(["../components/ShuJuTongJi/index.vue"], resolve)
        },
        {
          path: "ShuJuTongJiRiTongJI",
          name: "ShuJuTongJiRiTongJI",
          meta: { title: "日数据统计" },
          component: resolve =>
            require(["../components/ShuJuTongJi/RiTongJI.vue"], resolve)
        },
        {
          path: "GuanLIYuanIndex",
          name: "GuanLIYuanIndex",
          meta: { title: "添加管理员" },
          component: resolve =>
            require(["../components/GuanLIYuan/index.vue"], resolve)
        },
        {
          path: "SheZhiIndex",
          name: "SheZhiIndex",
          meta: { title: "个人信息" },
          component: resolve =>
            require(["../components/SheZhi/index.vue"], resolve)
        },
        {
          path: "SheZhiTiXianLieBiao",
          name: "SheZhiTiXianLieBiao",
          meta: { title: "账户信息" },
          component: resolve =>
            require(["../components/SheZhi/TiXianLieBiao.vue"], resolve)
        },
        {
          path: "FuZhuGongNengXiaZaiZhongXin",
          name: "FuZhuGongNengXiaZaiZhongXin",
          meta: { title: "下载中心" },
          component: resolve =>
            require(["../components/FuZhuGongNeng/XiaZaiZhongXin.vue"], resolve)
        },
        {
          path: "FuZhuGongNengKeHuChi",
          name: "FuZhuGongNengKeHuChi",
          meta: { title: "客户池列表" },
          component: resolve =>
            require(["../components/FuZhuGongNeng/KeHuChi.vue"], resolve)
        }
      ]
    }
  ]
});
vuerouter.beforeEach((to, from, next) => {
  let url = next();
  if (to.name != "login" && !window.localStorage.getItem("SaasToken")) {
    url = next("/");
  }
  return url;
});
export default vuerouter;



// WEBPACK FOOTER //
// ./src/router/index.js